// extracted by mini-css-extract-plugin
module.exports = {"backgroundPreview":"colorPicker_backgroundPreview__X88xU","colorPickerPopover":"colorPicker_colorPickerPopover__CiaLg"};